import { render, staticRenderFns } from "./BusCommonManageAppVersionList.vue?vue&type=template&id=2e32402e&scoped=true&"
import script from "./BusCommonManageAppVersionList.vue?vue&type=script&lang=js&"
export * from "./BusCommonManageAppVersionList.vue?vue&type=script&lang=js&"
import style0 from "./BusCommonManageAppVersionList.vue?vue&type=style&index=0&id=2e32402e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e32402e",
  null
  
)

export default component.exports